import { Event_ } from '../Event_';
export class DraggableEvent_ extends Event_ {
    get nativeMouseEvent() {
        return this.rawEvent.mouseEvent;
    }
    get pageXInPixel() {
        return this.nativeMouseEvent.pageX;
    }
    get pageYInPixel() {
        return this.nativeMouseEvent.pageY;
    }
    get stageXInPixel() {
        return this.pageXInPixel - this.app.stage.inner.aspectMount.measureToWindowIncludingTransform.aspectLeftInPixel;
    }
    get stageYInPixel() {
        return this.pageYInPixel - this.app.stage.inner.aspectMount.measureToWindowIncludingTransform.aspectTopInPixel;
    }
}
